export default "__VITE_ASSET__BxQVdP2E__"